"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InlineCalendar = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useFormState2 = _interopRequireDefault(require("../hooks/useFormState"));

var _pickers = require("@material-ui/pickers");

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _Day = _interopRequireDefault(require("./Day"));

var _dateFns2 = require("date-fns");

var _events = require("../utils/events");

var _excluded = ["onChange"],
    _excluded2 = ["renderCustomDay", "dayButtonDataQa"];

var InlineCalendar = function InlineCalendar(_ref) {
  var onChange = _ref.onChange,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var handleChange = function handleChange(date, value, handlers, context) {
    // TODO: This is probably not necessary. This component allows for a mask and or formatting
    // https://material-ui-pickers.dev/api/KeyboardDatePicker
    var formattedDate = (0, _dateFns2.isValid)(new Date(value)) ? (0, _dateFns2.format)(new Date(value), 'yyyy-MM-dd') : value; // The KeyboardDatePicker component doesn't pass an event back.
    // This mocks some of that information to make a somewhat more consistent interface
    // with other inputes.

    var event = (0, _events.eventStandin)({
      target: {
        type: 'date',
        name: props.name
      }
    });

    if (onChange) {
      onChange(event, value, handlers, context);
    } else {
      helpers.setValue(formattedDate);
    }
  };

  var _useFormState = (0, _useFormState2["default"])((0, _extends2["default"])({}, props, {
    onChange: handleChange
  })),
      onBlur = _useFormState.onBlur,
      name = _useFormState.name,
      helperText = _useFormState.helperText,
      value = _useFormState.value,
      error = _useFormState.error,
      helpers = _useFormState.helpers,
      onChangeState = _useFormState.onChange;

  var renderCustomDay = props.renderCustomDay,
      dayButtonDataQa = props.dayButtonDataQa,
      newProps = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-qa": newProps.dataQa
  }, /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _dateFns["default"]
  }, /*#__PURE__*/_react["default"].createElement(_pickers.KeyboardDatePicker, (0, _extends2["default"])({
    disableToolbar: true,
    onBlur: onBlur,
    name: name,
    helperText: helperText,
    value: (0, _dateFns2.isValid)((0, _dateFns2.parseISO)(value)) ? (0, _dateFns2.format)((0, _dateFns2.parseISO)(value), 'MM/dd/yyyy') : value,
    error: error,
    renderDay: function renderDay(date, selectedDate, dayInCurrentMonth, DayComponent) {
      var renderCustomDayFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : renderCustomDay;
      var dayButtonDataQaProp = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : dayButtonDataQa;
      return /*#__PURE__*/_react["default"].createElement(_Day["default"], {
        date: date,
        selectedDate: selectedDate,
        dayInCurrentMonth: dayInCurrentMonth,
        DayComponent: DayComponent,
        renderCustomDayFunction: renderCustomDayFunction,
        dayButtonDataQaProp: dayButtonDataQaProp
      });
    },
    format: "MM/dd/yyyy"
  }, newProps, {
    onChange: onChangeState,
    autoOk: true
  }))));
};

exports.InlineCalendar = InlineCalendar;
InlineCalendar.propTypes = {
  /** onChange callback called upon change of selected date */
  onChange: _propTypes["default"].func,

  /** Calendar Value */
  value: _propTypes["default"].instanceOf(Date),

  /**Calendar container type option  */
  variant: _propTypes["default"].string,

  /** Right arrow icon. */
  rightArrowIcon: _propTypes["default"].element,

  /** Left arrow icon. */
  leftArrowIcon: _propTypes["default"].element,

  /** Props to pass to right arrow button */
  rightArrowButtonProps: _propTypes["default"].object,

  /** Props to pass to left arrow button */
  leftArrowButtonProps: _propTypes["default"].object,

  /** DataQa attribute for each calendar day */
  dayButtonDataQaProp: _propTypes["default"].string,

  /** Custom renderer for specific days. */
  renderCustomDay: _propTypes["default"].func,

  /** Disable specific dates. */
  shouldDisableDate: _propTypes["default"].func
};
InlineCalendar.defaultProps = {
  'data-qa': 'calendar-container',
  leftArrowButtonProps: {
    'data-qa': 'calendar-arrow-left'
  },
  rightArrowButtonProps: {
    'data-qa': 'calendar-arrow-right'
  }
};
var _default = InlineCalendar;
exports["default"] = _default;